module.exports = __webpack_public_path__ + "assets/img/linechart.987e79b6.svg";